import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { QcFailedResponse } from '../models/search-filters.model';

export const OpenCreateNewTagDialog = createAction(
  '[Data Customization: Tag Management Create New]: Open New Tag Dialog',
);

export const LoadTagTypes = createAction(
  '[Data Customization: Tag Management Create New]: Tags Loaded',
  props<{ createTagTypeValues: string[] }>(),
);

export const CreateTagTypeChanged = createAction(
  '[Data Customization: Tag Management Create New]: Tag Type Changed',
  props<{ createTagType: string }>(),
);

export const CreateTagCodeChanged = createAction(
  '[Data Customization: Tag Management Create New]: Tag Code Changed',
  props<{ createTagCode: string }>(),
);

export const CreateTagLabelChanged = createAction(
  '[Data Customization: Tag Management Create New]: Tag Label Changed',
  props<{ createTagLabel: string }>(),
);

export const UserSubmitted = createAction('[Data Customization: Tag Management Create New]: User Submitted');

export const SaveTag = createAction('[Data Customization: Tag Management Create New]: Save Tag');

export const SaveTagSuccess = createAction(
  '[Data Customization: Tag Management Create New]: Save Tag Success',
  props<{ res: QcResponse }>(),
);

export const SaveTagFailed = createAction(
  '[Data Customization: Tag Management Create New]: Save Tag Failed',
  props<{ error: QcFailedResponse }>(),
);

export const ResetCreateNewState = createAction('[Data Customization: Tag Management Create New]: Reset Create Tags');
